import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-icon',
  templateUrl: './app-icon.component.html',
  styleUrls: ['./app-icon.component.scss'],
  imports: [CommonModule, MatIconModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppIconComponent implements OnInit {
  @Input() icon: string = '';
  @Input() class: string = '';
  // Optional ligature for Material Icons, e.g., 'mic', 'stop'
  @Input() matIcon?: string;
  // Optional Font Awesome icon name, e.g., 'microphone', 'stop'
  @Input() faIcon?: string;
  // Font Awesome style prefix: 'solid' | 'regular' | 'brands'
  @Input() faStyle: 'solid' | 'regular' | 'brands' = 'solid';

  // this is to prevent the icon from being loaded multiple times while navigating between pages
  private static loadedIcons = new Set<string>();
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    // Only register SVGs when not using Material or Font Awesome ligature icons
    if (!this.matIcon && !this.faIcon) {
      this.loadCustomSvgResources();
    }
  }

  get faStyleClass(): string {
    return `fa-${this.faStyle}`;
  }

  private loadCustomSvgResources() {
    if (!this.icon) return;

    if (!AppIconComponent.loadedIcons.has(this.icon)) {
      this.iconRegistry.addSvgIcon(
        this.icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${this.icon}.svg`),
      );
      AppIconComponent.loadedIcons.add(this.icon);
    }
  }
}
